import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Container from "@mui/material/Container";
import TokenLimitModificationForm from "../components/TokenLimitModificationForm";
import TokenPriceForm from "../components/TokenPriceForm";

function ChatTokenLength() {
  return (
    <MKBox component="section" py={12} px={1}>
      <Container>
        <MKTypography variant="h3">Lengte van het gesprek</MKTypography>
        <MKTypography variant="body2" fontWeight="regular" color="text">
          De chatbot heeft een maximum aantal tokens dat hij kan gebruiken. Als het gesprek deze
          limiet bereikt, wordt het gesprek afgerond. De chatbot geeft wel het laatste antwoord aan
          de gebruiker en sluit het gesprek netjes af. Hiervoor worden ook nog wat tokens gebruikt{" "}
          <strong>nadat</strong> de limiet is bereikt.
        </MKTypography>
        <MKBox mt={3}>
          <TokenLimitModificationForm />
        </MKBox>
        <MKTypography variant="body2" fontWeight="regular" color="text">
          OpenAI gebruikt twee soorten tokens:
        </MKTypography>
        <MKBox component="ul" p={0} m={1}>
          <MKBox component="li" p={0} m={0} lineHeight={1.25}>
            <MKTypography variant="body2" fontWeight="regular" color="text">
              <strong>Input:</strong> alles wat de chatbot als prompt naar ChatGPT stuurt.
            </MKTypography>
          </MKBox>
          <MKBox component="li" p={0} m={0} lineHeight={1.25}>
            <MKTypography variant="body2" fontWeight="regular" color="text">
              <strong>Output:</strong> alles wat de chatbot als antwoord van ChatGPT ontvangt.
            </MKTypography>
          </MKBox>
        </MKBox>
        <MKTypography variant="body2" fontWeight="regular" color="text">
          De chatbot rekent alle tokens om naar <strong>output</strong> tokens om de lengte van het
          gesprek te berekenen. Voer hieronder de prijs van tokens in zoals aangegeven op de{" "}
          <a
            href="https://platform.openai.com/docs/pricing"
            target="_blank"
            rel="noopener noreferrer"
          >
            OpenAI website
          </a>
          .
        </MKTypography>
        <MKBox mt={3}>
          <TokenPriceForm
            settingKey="input-token-price"
            title="Input Tokens"
            description="Prijs per 1 Miljoen input token."
          />
        </MKBox>
        <MKBox mt={3}>
          <TokenPriceForm
            settingKey="output-token-price"
            title="Output Tokens"
            description="Prijs per 1 Miljoen output token."
          />
        </MKBox>
      </Container>
    </MKBox>
  );
}

export default ChatTokenLength;
